import {homePageData} from '../utils'

export const learningCenterPageTypes = {
    GOAL: 'goal',
    MODULE: 'module',
    DEFAULT: 'default',
    ARTICLE: 'article'
}
export const learningCenterArticlePageTypes = {
    ARTICLE: 'article',
    ARTICLE_TOPIC: 'article-topic'
}

export const learningCenterPageData = {
    '@type': '@builder.io/sdk:Element',
    component: {
        name: 'BreadcrumbLink',
        options: {
            isClickable: true,
            pageReference: {
                '@type': '@builder.io/core:Reference',
                model: 'page',
                value: {data: {url: '/learning-center', title: 'HSA Learning Center'}}
            },
            label: 'HSA Learning Center'
        }
    }
}

export const articlesPageData = (isClickable = true) => ({
    '@type': '@builder.io/sdk:Element',
    component: {
        name: 'BreadcrumbLink',
        options: {
            isClickable,
            pageReference: {
                '@type': '@builder.io/core:Reference',
                model: 'page',
                value: {data: {url: '/learning-center/articles', title: 'Articles'}}
            },
            label: 'Articles'
        }
    }
})

export const addStaticCrumbs = (crumbs) => [homePageData, learningCenterPageData, ...crumbs]
